
import { Options, Vue } from 'vue-class-component'
import Employee from '@/employee/Employee'
import ValueMeter from '@/components/ui/ValueMeter.vue'

@Options({
  components: {
    ValueMeter
  },
  props: {
    image: String, title: String, employee: Employee
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  }
})
export default class EmployeeCardSmall extends Vue {
  image!: string
  title!: string
  employee!: string
}
